export default __webpack_public_path__ + "static/media/Comptes_Ajouter.4f0ebf0b.png";